import { FIELD_TYPES } from "constants/template-field-type";
import CarouselFieldsConfig from "segments/desktop/core-components/carousel/fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Carousel",
  fields: {
    disableCenterModeStyle: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Disable center mode style"
    },
    imageHeight: {
      type: FIELD_TYPES.TEXT,
      label: "Images height"
    },
    horizontalPadding: {
      type: FIELD_TYPES.TEXT,
      label: "Images horizontal padding"
    },
    transitionSpeed: {
      type: FIELD_TYPES.TEXT,
      label: "Slides transition speed (in miliseconds)"
    },
    ...CarouselFieldsConfig
  }
};
